/*
 * @Descripttion:调用后端md接口的函数
 * @Author: congz
 * @Date: 2020-06-12 23:26:38
 * @LastEditors: congz
 * @LastEditTime: 2020-08-04 11:13:59
 */

import axios from 'axios'

// 公告详情
const showNotice = (id) => axios.get('/api/v1/notices?id='+id).then(res => res.data)

// 商铺信息（从env读取）
const getShopInfo = () => axios.get('/api/v1/shop-info').then(res => res.data)

export { showNotice, getShopInfo }
